import LiquidIf from './liquid-if';

export default LiquidIf.extend({
  helperName: 'liquid-unless',
  inverted: true
});
